import { Check } from 'lucide-react'

interface ProgressStepperProps {
  currentStep: number
  labels?: string[]
}

const defaultLabels = ['Video Details', 'Visibility']

export function ProgressStepper({ currentStep, labels = defaultLabels }: ProgressStepperProps) {
  // Adjust currentStep to account for removed step 0
  // Now step 1 becomes index 0, step 2 becomes index 1
  const adjustedStep = currentStep - 1;

  return (
    <div className="flex items-center justify-center gap-6 mb-8">
      {labels.map((label, i) => {
        const isCompleted = i < adjustedStep
        const isActive = i === adjustedStep
        return (
          <div key={i} className="flex items-center gap-2">
            {/* Step circle */}
            <div
              className={`w-7 h-7 rounded-full flex items-center justify-center text-sm font-medium transition-colors duration-200
                ${isCompleted ? 'bg-green-500 text-white border-2 border-green-500' : ''}
                ${isActive && !isCompleted ? 'border-2 border-white text-white' : ''}
                ${!isCompleted && !isActive ? 'border-2 border-gray-500 text-gray-400' : ''}
              `}
            >
              {isCompleted ? <Check className="w-4 h-4" /> : i + 1}
            </div>

            {/* Label */}
            <span className="text-sm text-white whitespace-nowrap">{label}</span>

            {/* Connector line */}
            {i < labels.length - 1 && (
              <div
                className={`w-16 h-0.5 mx-2 ${
                  isCompleted ? 'bg-green-500' : 'bg-gray-600'
                }`}
              />
            )}
          </div>
        )
      })}
    </div>
  )
}